<div #quillContainer [attr.aria-label]="language.richTextEditor"  aria-multiline="true" role="textbox" aria-describedby="editor-instructions"></div>
<div id="editor-instructions" class="sr-only">
  {{language.quillAnswerInputInstruction}}
</div>
<!-- Clear Text Confirmation Modal -->
<ng-template #clearTextModal let-modal>
    <div class="modal-body text-center py-4" role="dialog" aria-modal="true" aria-labelledby="clearTextTitle" aria-describedby="clearTextDescription">
      <p class="fw-bold fs-5 mb-3" id="clearTextDescription">{{language.areYouSure}}</p>
    </div>
    <div class="modal-footer justify-content-center gap-2">
      <button type="button" class="btn btn-secondary btn-sm px-4" (click)="modal.close('yes')" [attr.aria-label]="language.confirmClearText">{{language.yes}}</button>
      <button type="button" class="btn btn-danger btn-sm px-4" (click)="modal.dismiss('no')" [attr.aria-label]="language.cancelClearText" autofocus>{{language.no}}</button>
    </div>
  </ng-template>